import { Descriptions, Spin, Tabs } from 'antd'
import { get } from 'lodash'
import moment from 'moment'
import React from 'react'
import useFetchURL from '../../../../../elements/Hooks/useFetchURL'
import CustomTable from '../../../../../elements/Table/CustomTable'

const { TabPane } = Tabs
const { Item } = Descriptions

function WordpressOrder({ line }) {
  const { order } = line

  const type = line.realm
  const isClearFog = type === 'https://clearfog.co.uk'
  const isCleanMist = type === 'https://cleanmist.com.au'

  const keysMap = {
    'https://clearfog.co.uk':
      'consumer_key=ck_5f62313aadb040fc7ce3498e13d4b6c548e8bd15&consumer_secret=cs_df25eea4b8887606d12ee7a97a608d16a58fb164',
    'https://cleanmist.com.au':
      'consumer_key=ck_7602c2ffe761de1880140e85eaf566c403ed7b1a&consumer_secret=cs_9830991ff92a21ff0494eeb6fe88034d3b59cba6',
  }

  const url = `${get(order, '_links.self[0].href')}?${keysMap[type]}`

  const { data, fetching, fetchURL: fetch } = useFetchURL(url, [url], !url)

  const currency = get(order, 'currency')

  return (
    <Spin spinning={fetching}>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Order" key="1">
          <Descriptions title="User Info" column={2} bordered>
            <Item label="Status">{get(line, 'status', get(data, 'status'))}</Item>
            <Item label="Currency">{get(data, 'currency')}</Item>
            <Item label="Date Created">{moment(get(data, 'date_created')).format('YYYY-MM-DD')}</Item>
            <Item label="Date Paid">{moment(get(data, 'date_paid')).format('YYYY-MM-DD')}</Item>
            <Item label="Client Name">{`${get(data, 'billing.first_name')} ${get(data, 'billing.last_name')}`}</Item>
            <Item label="Company">{get(data, 'billing.company')}</Item>
            <Item label="Total">{get(data, 'total')}</Item>
            <Item label="Total Tax">{get(data, 'total_tax')}</Item>
          </Descriptions>

          <CustomTable
            data={data.line_items}
            fetching={fetching}
            fetch={fetch}
            columns={[
              { Header: 'ID', accessor: 'id' },
              { Header: 'name', accessor: 'name' },
              { Header: 'product_id', accessor: 'product_id' },
              { Header: 'SKU ID', accessor: 'variation_id' },
              { Header: 'quantity', accessor: 'quantity' },
              { Header: 'subtotal', accessor: 'subtotal' },
              { Header: 'subtotal_tax', accessor: 'subtotal_tax' },
              { Header: 'total', accessor: 'total' },
              { Header: 'total_tax', accessor: 'total_tax' },
              { Header: 'price', accessor: 'price' },
            ]}
          />
        </TabPane>
        <TabPane tab="Payment Info" key="2">
          <Descriptions title="Payment Info" column={2} bordered>
            <Item label="Discount Total">
              {get(order, 'discount_total')} {currency}
            </Item>
            <Item label="Discount Tax">
              {get(order, 'discount_tax')} {currency}
            </Item>
            <Item label="Shipping Total">
              {get(order, 'shipping_total')} {currency}
            </Item>
            <Item label="Shipping Tax">
              {get(order, 'shipping_tax')} {currency}
            </Item>
            <Item label="Cart Tax">
              {get(order, 'cart_tax')} {currency}
            </Item>
            <Item label="Total">
              {get(order, 'total')} {currency}
            </Item>
            <Item label="Total Tax">
              {get(order, 'total_tax')} {currency}
            </Item>
            <Item label="Prices Include Tax">{get(order, 'prices_include_tax') ? 'Yes' : 'No'}</Item>
            <Item label="Payment Method">{get(order, 'payment_method')}</Item>
            <Item label="Payment method Title">{get(order, 'payment_method_title')}</Item>
            <Item label="Transaction ID">{get(order, 'transaction_id')}</Item>
          </Descriptions>
        </TabPane>
        <TabPane tab="Billing/Shipping" key="3">
          <Descriptions title="Billing Info" column={2} bordered>
            <Item label="First Name">{get(order, 'billing.first_name')}</Item>
            <Item label="Last Name">{get(order, 'billing.last_name')}</Item>
            <Item label="Company">{get(order, 'billing.company')}</Item>
            <Item label="Address 1">{get(order, 'billing.address_1')}</Item>
            <Item label="Address 2">{get(order, 'billing.address_2')}</Item>
            <Item label="City">{get(order, 'billing.city')}</Item>
            <Item label="State">{get(order, 'billing.state')}</Item>
            <Item label="Postcode">{get(order, 'billing.postcode')}</Item>
            <Item label="Country">{get(order, 'billing.country')}</Item>
            <Item label="Email">{get(order, 'billing.email')}</Item>
            <Item label="Phone">{get(order, 'billing.phone')}</Item>
          </Descriptions>

          <Descriptions title="Shipping Info" size={2} bordered>
            <Item label="First Name">{get(order, 'shipping.first_name')}</Item>
            <Item label="Last Name">{get(order, 'shipping.last_name')}</Item>
            <Item label="Company">{get(order, 'shipping.company')}</Item>
            <Item label="Address 1">{get(order, 'shipping.address_1')}</Item>
            <Item label="Address 2">{get(order, 'shipping.address_2')}</Item>
            <Item label="City">{get(order, 'shipping.city')}</Item>
            <Item label="State">{get(order, 'shipping.state')}</Item>
            <Item label="Postcode">{get(order, 'shipping.postcode')}</Item>
            <Item label="Country">{get(order, 'shipping.country')}</Item>
          </Descriptions>
        </TabPane>
      </Tabs>
    </Spin>
  )
}

export default WordpressOrder
